import { ExpandableCostInput } from './ExpandableCostInput';

interface RunningCostsInputProps {
  values: {
    hausgeld: number | null;
    hausgeldNonAllocable: number | null;
    reserve: number | null;
    management: number | null;
    insurance: number | null;
    propertyTax: number | null;
    other: number | null;
  };
  onChange: (values: RunningCostsInputProps['values']) => void;
}

export function RunningCostsInput({ values, onChange }: RunningCostsInputProps) {
  // Berechne nicht-umlagefähige Kosten
  const nonAllocableTotal =
    (values.hausgeldNonAllocable || 0) +
    (values.reserve || 0) +
    (values.management || 0) +
    (values.insurance || 0) +
    (values.propertyTax || 0) +
    (values.other || 0);

  const items = [
    { key: 'hausgeld', label: 'Hausgeld gesamt', value: values.hausgeld },
    { key: 'hausgeldNonAllocable', label: 'davon nicht umlagefähig', value: values.hausgeldNonAllocable },
    { key: 'reserve', label: 'Rücklagen', value: values.reserve },
    { key: 'management', label: 'Verwaltung', value: values.management },
    { key: 'insurance', label: 'Versicherung', value: values.insurance },
    { key: 'propertyTax', label: 'Grundsteuer (wenn nicht umgelegt)', value: values.propertyTax },
    { key: 'other', label: 'Sonstiges', value: values.other },
  ];

  const handleItemChange = (key: string, value: number | null) => {
    onChange({
      ...values,
      [key]: value,
    });
  };

  return (
    <ExpandableCostInput
      label="Laufende Kosten (monatlich)"
      totalValue={nonAllocableTotal}
      onTotalChange={() => {}}  // Total wird berechnet
      items={items}
      onItemChange={handleItemChange}
      helpText="Nur Kosten eingeben, die nicht auf den Mieter umgelegt werden können"
    />
  );
}
